module.exports = __webpack_public_path__ + "img/img8.ed9896c9.png";